import { render } from "./add-reservation.vue?vue&type=template&id=6665a3ac"
import script from "./add-reservation.vue?vue&type=script&lang=js"
export * from "./add-reservation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__